// import React, { useState } from 'react';

import PlaybackLine from './PlaybackLine';

// import play_black from '../../Images/play_black.svg';
// import pause_black from '../../Images/pause_black.svg';
// import video_black from '../../Images/video_black.svg';
// import headphones_black from '../../Images/headphones_black.svg';
import play_circle from '../../Images/play-circle-bold.svg';
import pause_circle from '../../Images/pause-circle-bold.svg';

const MusicPlayer2 = ({song,i,id,playPressed,playing,width,height,item,dimensions,playBack,setPlayBack,audioRef}) => {
	// const [ playBack, setPlayBack ] = useState(0);

	// const audioRef = useRef();

	function playClicked(e,i) {
		const ref = document.getElementById(id);
		audioRef.current = ref;
		playPressed(e,i);
	}

	function timeDisplay() {
		let minutes = 0;
		let seconds = '00';
		let currentMinutes = '0';
		let currentSeconds = '00';
		if(audioRef.current !== undefined){
			if(audioRef.current.duration !== undefined && !isNaN(audioRef.current.duration)){
				minutes = Math.floor(audioRef.current.duration/60);
				seconds = Math.round(audioRef.current.duration%60);
				if(seconds < 10) seconds = '0'+seconds;
			}
			currentMinutes = Math.floor(playBack/60);
			currentSeconds = Math.round(playBack%60);
			if(currentSeconds < 10) currentSeconds = '0'+currentSeconds;
		}
		return currentMinutes+':'+currentSeconds+' - '+minutes+':'+seconds;
	}

	let className = 'hoverOpacityUp mainText pointer';
	let bold = 'normal';
	let opacity = 0.3;
	if(playing.id === id){
		className = ' mainText pointer';
		opacity = 0.8;
		// if(width > 460) bold = 'bold';
	}
	return(
		<div>
			<div style={{width:width,height:height-3,fontWeight:bold}} className={className}
					onClick={()=>{playClicked(id,i)}}>
				<audio id={id}
						// ref={audioRef}
						onTimeUpdate={()=>{if(audioRef.current !== undefined) setPlayBack(Math.floor(audioRef.current.currentTime)) }}>
					<source src={song.audio} type='audio/mpeg' />
					<source src={song.audio} type='audio/wav' />
				</audio>
				<div className='flexCenter pointer absolute relative' style={{width:height-3,height:height-4,zIndex:2}}>
					{playing.id === id && playing.play === true
						? <img src={pause_circle} alt='pause-circle' style={{height:30}} />
						: <img src={play_circle} alt='play-circle' style={{height:30}} />
					}
				</div>
				<div className='flexHeightCenter'>
					<div className='flexCenter pointer' style={{height:height-3,width:height-3,overflow:'hidden',background:'black'}}>
						<img src={item.thumbnail} alt='play-circle' style={{width:'100%',opacity:opacity}} />
					</div>

					<div style={{marginLeft:10,width:width-height-96}}>{song.name} - Andy Marsh</div>

					{timeDisplay()}
				</div>

				{/*<div style={{width:width,height:80,marginTop:-80,backgroundImage:'linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.8))'}} className='flexHeightBottom appText absolute'>
					<div style={{width:'60%',marginBottom:10}} className='flexHeightCenter'>
						<div style={{marginLeft:14}}>{song.name} - Andy Marsh</div>
					</div>
					<div style={{width:'40%',marginBottom:10}} className='flexRight'>
						{timeDisplay()}
						<div style={{width:14}}></div>
					</div>
				</div>*/}
			</div>
			{playing.id === id
				? <PlaybackLine audioRef={audioRef} playBack={playBack} width={width} dimensions={dimensions} height={8} />
				: <PlaybackLine audioRef={{current:undefined}} playBack={playBack} width={width} dimensions={dimensions} height={8} />
			}
			{/*{audioRef.current !== undefined
				? <div style={{width:'100%'}} className='flexCenter'>
					<div style={{width:`${playBack/audioRef.current.duration*width}%`,borderBottom:'4px solid rgb(255,20,170'}}></div>
					<div style={{width:`${width-(playBack/audioRef.current.duration*width)}%`,borderBottom:'4px solid rgb(120,120,120)'}}></div>
				</div>
				: <div style={{width:`100%`,borderBottom:'6px solid rgb(230,230,230)'}}></div>
			}*/}
		</div>
	)

	// return(
	// 	<div style={{width:width,height:height,color:'white'}} className=''>
	// 		<audio id={id} ref={audioRef} onTimeUpdate={()=>{setPlayBack(Math.floor(audioRef.current.currentTime))}}>
	// 			<source src={song.audio} type='audio/mpeg' />
	// 			<source src={song.audio} type='audio/wav' />
	// 		</audio>
	// 		<div className='flexCenter pointer absolute hoverOpacityUp' style={{height:height-3,width:width,zIndex:2,backgroundImage:'radial-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0))'}}
	// 				onClick={()=>{playPressed(id)}}>
	// 			{playing.id === id && playing.play === true
	// 				? <img src={pause_circle} alt='play-circle' style={{height:70}} />
	// 				: <img src={play_circle} alt='play-circle' style={{height:70}} />
	// 			}
	// 		</div>
	// 		<div className='flexCenter pointer' style={{height:height-3,width:width}}>
	// 			<img src={item.thumbnail} alt='play-circle' style={{height:'94%'}} />
	// 		</div>
	// 		<div style={{width:width,height:80,marginTop:-80,backgroundImage:'linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.8))'}} className='flexHeightBottom appText absolute'>
	// 			<div style={{width:'60%',marginBottom:10}} className='flexHeightCenter'>
	// 				{/*<div style={{width:30}} className='flexCenter'>
	// 					{playing.id === id && playing.play === true
	// 						? <img src={pause_black} alt='play_black' style={{height:30}}
	// 								className='pointer' onClick={()=>{playPressed(id)}} />
	// 						: <img src={play_black} alt='play_black' style={{height:30}}
	// 								className='pointer' onClick={()=>{playPressed(id)}} />
	// 					}
	// 				</div>*/}
	// 				<div style={{marginLeft:14}}>{song.name} - Andy Marsh</div>
	// 			</div>
	// 			<div style={{width:'40%',marginBottom:10}} className='flexRight'>
	// 				{timeDisplay()}
	// 				<div style={{width:14}}></div>
	// 			</div>
	// 		</div>
	// 		{audioRef.current !== undefined
	// 			? <div style={{width:'100%'}} className='flexCenter'>
	// 				<div style={{width:`${playBack/audioRef.current.duration*width}%`,borderBottom:'3px solid rgb(60,150,255)'}}></div>
	// 				<div style={{width:`${width-(playBack/audioRef.current.duration*width)}%`,borderBottom:'3px solid rgb(120,120,120)'}}></div>
	// 			</div>
	// 			: <div style={{width:`100%`,borderBottom:'3px solid rgb(230,230,230)'}}></div>
	// 		}
	// 	</div>
	// )
}

export default MusicPlayer2;